import { render, staticRenderFns } from "./AssistanceTable.vue?vue&type=template&id=b4ae5f8a&"
import script from "./AssistanceTable.vue?vue&type=script&lang=js&"
export * from "./AssistanceTable.vue?vue&type=script&lang=js&"
import style0 from "./AssistanceTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports